import { render, staticRenderFns } from "./aboutView.vue?vue&type=template&id=7e885cd6"
import script from "./aboutView.vue?vue&type=script&lang=js"
export * from "./aboutView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports